import * as React from "react";
import { MenuItem, FormControl, Select,Input } from "@material-ui/core";

import useStyles from "./styles";

export default function SelectBreak(props) {
    var classes = useStyles();
    var breakReasons = Array.from(props.breakReasons);

    //const [breakType, setbreakType] = React.useState("");

    /*const handleChange = (event) => {
        setbreakType(event.target.value);
    };*/
    let breakDiv = <MenuItem value="Break">Break</MenuItem>;
    if (!props.loading && breakReasons && props.error !== "No break_reason") {
        breakDiv = breakReasons.map((item) => (
            <MenuItem key={item.break_reason} value={item.break_reason}>
                {item.break_reason}
            </MenuItem>
        ));
    }
    return (
      <div className={classes.progressSection}>
            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <Select
                    className={classes.BreakButton}
                    value={props.breakType}
                    onChange={(e) => props.breakClicked(e.target.value)}
                    displayEmpty
                    disabled={
                        props.agentState === "BREAK" ||
                        props.agentState === "READY"
                            ? true
                            : false
                    }
                    inputProps={{ "aria-label": "Without label" }}
                    input={
                        <Input
                            disableUnderline
                            classes={{ input: classes.selectInput }}
                        />
                    }
                >
                    <MenuItem value="null">Take Break</MenuItem>
                    {breakDiv}
                </Select>
            </FormControl>
        </div>
    );
}
